"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TextButton = _interopRequireDefault(require("@insided/deprecated-control/ui-components/TextButton"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

var _GlobalClick = _interopRequireDefault(require("@insided/shared/uikit/GlobalClick"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Dropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false,
      isTriggerClicked: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hoverEnterTimeout", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hoverLeaveTimeout", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEscapeClick", function (e) {
      if (e.code === 'Escape') {
        _this.setState({
          isOpen: false
        });

        return;
      }

      var arrowKeyCallback = _this.props.onGlobalKey;
      if (!arrowKeyCallback || !_this.state.isOpen) return;

      if (e.code === 'Enter') {
        arrowKeyCallback('enter');
      } else if (e.code === 'ArrowDown') {
        arrowKeyCallback('down');
        e.preventDefault();
      } else if (e.code === 'ArrowUp') {
        arrowKeyCallback('up');
        e.preventDefault();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        window.addEventListener('keydown', this.handleEscapeClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('keydown', this.handleEscapeClick);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _trigger;

      var _this$props = this.props,
          triggerComponent = _this$props.trigger,
          triggerElement = _this$props.triggerElement,
          children = _this$props.children,
          triggerClass = _this$props.triggerClass,
          openOnHover = _this$props.openOnHover,
          popupName = _this$props.popupName,
          disabled = _this$props.disabled,
          customClass = _this$props.class,
          className = _this$props.className,
          closeOnDropdownClick = _this$props.closeOnDropdownClick,
          onCloseCallback = _this$props.onCloseCallback;
      var trigger = null;

      if (typeof triggerComponent === 'function') {
        trigger = triggerComponent(this.state.isOpen);
      }

      var Trigger = triggerElement !== null && triggerElement !== void 0 ? triggerElement : _TextButton.default; // eslint-disable-next-line import/no-deprecated

      var renderPropChildren = (0, _typeGuards.getFirstChild)(children);
      return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions -- This is a dropdown container
        (0, _preact.h)("div", {
          className: (0, _classnames.default)('dropdown-container', triggerClass),
          onMouseEnter: openOnHover ? function () {
            if (_this2.hoverLeaveTimeout) clearTimeout(_this2.hoverLeaveTimeout);
            _this2.hoverEnterTimeout = setTimeout(function () {
              return _this2.setState({
                isOpen: true,
                isTriggerClicked: true
              });
            }, 100);
          } : undefined,
          onMouseLeave: openOnHover ? function () {
            if (_this2.hoverEnterTimeout) clearTimeout(_this2.hoverEnterTimeout);
            _this2.hoverLeaveTimeout = setTimeout(function () {
              return _this2.setState({
                isOpen: false,
                isTriggerClicked: false
              });
            }, 100);
          } : undefined
        }, (0, _preact.h)(Trigger, {
          id: popupName,
          "aria-haspopup": "true",
          "aria-expanded": this.state.isOpen,
          disabled: disabled,
          onClick: function onClick() {
            if (disabled !== null && disabled !== void 0 ? disabled : openOnHover) {
              return;
            }

            _this2.setState(function (state) {
              return {
                isOpen: !state.isOpen,
                isTriggerClicked: true
              };
            });
          }
        }, (_trigger = trigger) !== null && _trigger !== void 0 ? _trigger : typeof triggerComponent === 'function' ? triggerComponent(this.state.isOpen) : triggerComponent), (0, _preact.h)(_GlobalClick.default, {
          "aria-labelledby": popupName,
          Component: "ul",
          tabIndex: -1,
          role: "menu",
          className: (0, _classnames.default)(className, customClass, {
            'is-hidden': !this.state.isOpen
          }),
          onChildrenClick: function onChildrenClick() {
            return closeOnDropdownClick ? _this2.setState({
              isOpen: false,
              isTriggerClicked: false
            }) : '';
          },
          onGlobalClick: function onGlobalClick() {
            _this2.state.isTriggerClicked ? _this2.setState({
              isTriggerClicked: false
            }) : _this2.setState({
              isOpen: false,
              isTriggerClicked: false
            });

            if (onCloseCallback) {
              onCloseCallback();
            }
          }
        }, (0, _typeGuards.isFunction)(renderPropChildren) && renderPropChildren({
          close: function close() {
            return _this2.setState({
              isOpen: false,
              isTriggerClicked: false
            });
          }
        }), children))
      );
    }
  }]);
  return Dropdown;
}(_preact.Component);

exports.default = Dropdown;